export const CREATE_COMPONENT_COMPONENT_SELECTED =
  'canvas/CREATE_COMPONENT_COMPONENT_SELECTED';
export const CREATE_DUPLICATE_COMPONENT = 'canvas/CREATE_DUPLICATE_COMPONENT';
export const GET_EXISTING_COMPONENTS_REQUESTED = 'canvas/GET_EXISTING_COMPONENTS_REQUESTED';
export const GET_EXISTING_COMPONENTS_REJECTED = 'canvas/GET_EXISTING_COMPONENTS_REJECTED';
export const GET_EXISTING_COMPONENTS_FULLFILLED = 'canvas/GET_EXISTING_COMPONENTS_FULLFILLED';
export const OPEN_COMPONENT_FOR_EDITING = 'canvas/OPEN_COMPONENT_FOR_EDITING';
export const OPEN_PARENT_COMPONENT_FOR_EDITING = 'canvas/OPEN_PARENT_COMPONENT_FOR_EDITING';
export const DELETE_COMPONENT_REQUESTED = 'canvas/DELETE_COMPONENT_REQUESTED';
export const DELETE_COMPONENT_REJECTED = 'canvas/DELETE_COMPONENT_REJECTED';
export const GET_IMAGE_SIZE_FOR_COMPONENT_FAILURE =
  'canvas/GET_IMAGE_SIZE_FOR_COMPONENT_FAILURE';
export const GET_IMAGE_SIZE_FOR_COMPONENT_REQUEST =
  'canvas/GET_IMAGE_SIZE_FOR_COMPONENT_REQUEST';
export const GET_IMAGE_SIZE_FOR_COMPONENT_RESPONSE =
  'canvas/GET_IMAGE_SIZE_FOR_COMPONENT_RESPONSE';
